<section class="content">
  <div class="card" style="padding:8px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <mat-label>From Date</mat-label>
        <input type="date" [(ngModel)]="from_date" (ngModelChange)="changeEvent()" class="main-border-class" />
      </div>
      <div class="col-3">
        <mat-label>To Date</mat-label>
        <input type="date" [(ngModel)]="to_date" (ngModelChange)="changeEvent()" class="main-border-class"
          [min]="from_date" />
      </div>
      <div class="col-3">
        <mat-label>Route &nbsp; <mat-checkbox (change)="checkboxChanged($event)" checked="true">All</mat-checkbox> </mat-label>
        <mat-select multiple style="border-radius: 10px; border: 1px solid black; padding: 17px;"
          [(ngModel)]="selected_route_list" [disabled]="route_disabled">
          <mat-option *ngFor="let route of route_list" [value]="route">{{route.name}}</mat-option>
        </mat-select>
      </div>
      <div class="col-2">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 11%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="to_date == null || from_date == null || selected_route_list.length === 0 ">Get</button>
      </div>
      <div *ngIf="!is_document_available">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
        </mat-progress-spinner>
      </div>
      <div class="col" *ngIf="document_file!== null">
        <button mat-button class="button-class" (click)="downloadClicked()" style="margin-top:25px"><i
            class="material-icons">
            picture_as_pdf
          </i> Download report</button>
      </div>
    </div>
  </div>

  <div class="row">
    <!-- <div class="col-4">
      <div class="card" style="padding:8px;background-color: aliceblue;">
        <div class="row" style="text-align: center;">
          <div class="col-6">
            <h1>Route List</h1>
            <div class="card" style="padding:8px; background-color: rgb(198, 223, 245);">
              <div *ngFor="let route of route_list">
                <div class="card" style="padding:12px; background-color: rgb(96, 123, 128);"
                  (click)="pushToRouteSelectedList(route)">
                  <div class="row" style="text-align: center; color: white; font-weight: bold;">
                    <div class="col">
                      {{route.name}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="card" style="padding:12px; background-color: rgb(96, 123, 128);"
                (click)="pushToRouteSelectedList('all')">
                <div class="row" style="text-align: center; color: white; font-weight: bold;">
                  <div class="col">
                    Select All
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <h1>Selected List</h1>
            <div class="card" style="padding:8px; background-color: aquamarine;">
              <div *ngFor="let route of selected_rout_list">
                <div class="card" style="padding:12px; background-color: rgb(121, 179, 159);"
                  (click)="pushToRouteList(route)">
                  <div class="row" style="text-align: center; color: white; font-weight: bold;">
                    <div class="col">
                      {{route.name}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="card" style="padding:12px; background-color: rgb(121, 179, 159);"
                (click)="pushToRouteList('all')">
                <div class="row" style="text-align: center; color: white; font-weight: bold;">
                  <div class="col">
                    Un Select All
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="col">
      <iframe [src]="pdf_data" width="100%" height="800" *ngIf="document_file!== null" style="margin-top: 1%;"></iframe>
    </div>
  </div>
</section>